import { render, staticRenderFns } from "./LayoutCards.vue?vue&type=template&id=060e8cba&"
import script from "./LayoutCards.vue?vue&type=script&lang=js&"
export * from "./LayoutCards.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LayoutCards.vue"
export default component.exports